import { createFileRoute } from "@tanstack/react-router";
import Index from "../pages/Index";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "CreceLocal: Más Clientes, Menos Oportunidades Perdidas" },
      {
        name: "description",
        content:
          "Armamos el sistema para que te encuentren en Google, respondas cada consulta y hagas seguimiento sin estar atrás de todo. Para empresas de servicios, distribuidoras y mayoristas.",
      },
      {
        property: "og:title",
        content: "CreceLocal: Más Clientes, Menos Oportunidades Perdidas",
      },
      {
        property: "og:description",
        content:
          "Armamos el sistema para que te encuentren en Google, respondas cada consulta y hagas seguimiento sin estar atrás de todo. Para empresas de servicios, distribuidoras y mayoristas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Index,
});
